/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': '뒤로',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': '참조 중',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': '작업',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Rovo에게 질문하기',
  'ai-smart-button.ai-actions.give-feedback-action.title': '피드백 제출',
  'ai-smart-button.ai-actions.help.section.text': '도움말',
  'ai-smart-button.ai-actions.input.link-picker-button-label': '링크',
  'ai-smart-button.ai-actions.input.mention-button-label': '멘션',
  'ai-smart-button.ai-actions.input.placeholder': '필요한 것을 입력하세요',
  'ai-smart-button.ai-actions.input.send-button-label': '보내기',
  'ai-smart-button.ai-actions.item.betaLozenge': '베타',
  'ai-smart-button.ai-actions.item.newLozenge': '신규',
  'ai-smart-button.ai-actions.no-results-heading': 'Rovo에게 질문하기',
  'ai-smart-button.ai-actions.no-results-text': '채팅을 시작하려면 Rovo에 프롬프트를 보내세요.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': '아이콘 추가',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': '에이전트 아이콘',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': '자동화 아이콘',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': '자동화',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': '에이전트 찾아보기',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': '에이전트 만들기',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': '자동화 만들기',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': '무엇을 도와드릴까요?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': '{name} 님, 안녕하세요.',
  'ai-smart-button.ai-proactive-nudge.dismiss': '해제',
  'ai-smart-button.feedback-action.ask-question-option': '질문하기',
  'ai-smart-button.feedback-action.can-contact-message':
    '예, {product} 팀에서 Atlassian 제품 및 서비스 개선을 위해 연락하여 제 경험에 대해 물어봐도 괜찮습니다. {privacyPolicy}을(를) 수락합니다',
  'ai-smart-button.feedback-action.cancel-button-label': '취소',
  'ai-smart-button.feedback-action.choose-feedback-option': '하나 선택',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': '버그 또는 이슈 설명',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': '의견을 알려주세요',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': '무엇을 알고 싶습니까?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': '개선하기 원하는 내용을 알려주세요',
  'ai-smart-button.feedback-action.leave-comment-option': '댓글 남기기',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product} 개인 정보 보호 정책.',
  'ai-smart-button.feedback-action.report-bug-option': '버그 보고',
  'ai-smart-button.feedback-action.research-participation-message': '제품 조사에 참여하고 싶습니다',
  'ai-smart-button.feedback-action.select-feedback-heading': '피드백 선택',
  'ai-smart-button.feedback-action.submit-button-label': '피드백 보내기',
  'ai-smart-button.feedback-action.suggest-improvement-option': '개선 사항 제안',
  'ai-smart-button.feedback-action.title': '피드백 제출',
  'ai-smart-button.feedback-item.icon-label': '피드백 아이콘',
  'ai-smart-button.reference.close-button-label': '닫기',
  'quick-summary.feedback.summary.placeholder':
    'Atlassian Intelligence는 어떤 부분에서 작업을 잘 수행했습니까? 개선할 점은 무엇입니까?',
  'quick-summary.feedback.title': 'Atlassian Intelligence를 개선하도록 도와주세요',
};
